<div
  class="min-h-screen mx-auto px-4 flex flex-col"
  *ngIf="config"
  [class.max-w-5xl]="config.screenRatio < 1"
  [class.max-w-xl]="config.screenRatio >= 1"
>
  <div id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo">
  </div>

  <ng-container *ngIf="config.enableAi">
    <content-block [slug]="'default-home-top'" id="default-home-top-wrapper" [class.hidden]="boothMode"></content-block>
    <content-block [slug]="'wbm-home-top'" id="wbm-home-top-wrapper" [class.hidden]=" ! boothMode"></content-block>
  </ng-container>

  <ng-container *ngIf=" ! config.enableAi">
    <content-block [slug]="'default-home-disabled-top'" id="default-home-disabled-top-wrapper" [class.hidden]="boothMode"></content-block>
    <content-block [slug]="'wbm-home-disabled-top'" id="wbm-home-disabled-top-wrapper" [class.hidden]=" ! boothMode"></content-block>
  </ng-container>

  <div id="sample-image-container" [ngStyle]="{'background-image': 'url('+getSampleUrl()+')'}">
    <img [src]="getSampleUrl()" alt="Sample image" class="sample-image aspect-square object-contain hidden sm:block">
  </div>

  <div id="front-page-text-wrapper" class="md:w-2/3 md:mx-auto">

    <ng-container *ngIf="config.enableAi">
      <content-block [slug]="'default-home-bottom'" id="default-home-bottom-wrapper" [class.hidden]="boothMode && config.enableAi"></content-block>
      <content-block [slug]="'wbm-home-bottom'" id="wbm-home-bottom-wrapper" [class.hidden]=" ! boothMode && config.enableAi"></content-block>
    </ng-container>

    <ng-container *ngIf=" ! config.enableAi">
      <content-block [slug]="'default-home-disabled-bottom'" id="default-home-disabled-bottom-wrapper" [class.hidden]="boothMode && ! config.enableAi"></content-block>
      <content-block [slug]="'wbm-home-disabled-bottom'" id="wbm-home-disabled-bottom-wrapper" [class.hidden]=" ! boothMode && ! config.enableAi"></content-block>
    </ng-container>

    <div class="mt-3" *ngIf=" ! config.enableTerms && config.enableAi">
      <button
        type="button"
        class="button-primary"
        (click)="goToNextPage()" i18n>Continue</button>
    </div>

    <div class="text-xl" *ngIf="config.enableTerms && config.enableAi">
      <form [formGroup]="form" (submit)="onSubmit()" class="flex flex-col">
        <label class="flex flex-row custom-check" for="agree">
          <input type="checkbox" value="" formControlName="agree" class="invisible" id="agree">
          <span class="checkmark"></span>
          <content-block [slug]="'terms-and-conditions-form'" (click)="termsModal()" id="terms-and-conditions-form-wrapper"></content-block>
          <span
            id="terms-and-conditions-trigger"
            [class.text-error-color]="submitted && form.invalid" i18n>
            Check box to agree to the <a (click)="termsModal()" class="text-link-color cursor-pointer">terms and conditions.</a>
          </span>
        </label>

        <button
          type="submit"
          class="button-primary"
          id="touch-to-start-button"
          i18n
        >Start</button>

      </form>
    </div>

  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper" [class.hidden]="boothMode"></content-block>
  <content-block [slug]="'wbm-disclaimer-bottom'" id="wbm-disclaimer-bottom-wrapper" [class.hidden]=" ! boothMode"></content-block>
</div>

<div id="tcs-modal-backdrop" #modal tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-screen max-h-full">
  <div class="relative p-4 w-full max-w-2xl max-h-full" id="tcs-modal">
    <!-- Modal content -->
    <div class="relative rounded-lg shadow">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t">
        <h3 class="text-xl font-semibold">
          Terms of Service
        </h3>
        <button
          type="button"
          (click)="dismiss()"
          class="text-gray-400 bg-transparent rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center hover:bg-neutral-600 hover:text-white">
          <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
      </div>
      <!-- Modal body -->
      <content-block class="block p-6" [slug]="'terms-and-conditions'"></content-block>
    </div>
  </div>
</div>
